// src/features/services/components/ServiceWorkspaceHeader.tsx
import type { Service } from './ServiceRow';
import { ServiceStatusBadge } from './ServiceStatusBadge';

interface ServiceWorkspaceHeaderProps {
  service: Service;
  onClose: () => void;
}

/**
 * Workspace panel header: service identity, status badge, and the
 * service identifier (the only identifier available on `Service`
 * today). Mirrors `OrderWorkspaceHeader` / `CustomerWorkspaceHeader`.
 */
export function ServiceWorkspaceHeader({ service, onClose }: ServiceWorkspaceHeaderProps) {
  return (
    <div className="border-b border-[var(--vania-colors-border-subtle,rgba(255,255,255,0.08))] px-4 py-3">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="truncate text-sm font-semibold text-[var(--vania-colors-text-primary,#f5f6fa)]">
            {service.name}
          </p>
          <p className="mt-0.5 truncate text-xs text-[var(--vania-colors-text-secondary,#a3aab8)]">
            شناسه سرویس: {service.id}
          </p>
        </div>

        <div className="flex shrink-0 items-center gap-2">
          <ServiceStatusBadge status={service.status} />
          <button
            type="button"
            onClick={onClose}
            aria-label="بستن فضای کاری سرویس"
            className="rounded-full p-1 text-[var(--vania-colors-text-secondary,#a3aab8)] transition-colors hover:bg-[var(--vania-colors-border-subtle,rgba(255,255,255,0.08))]"
          >
            ✕
          </button>
        </div>
      </div>
    </div>
  );
}
